import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { getCoverageColor } from './globalRosterUtils'

const RosterCoverageCards = ({ coverageItems }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: 'repeat(2, minmax(0, 1fr))',
        lg: 'repeat(5, minmax(0, 1fr))',
      },
      gap: 1,
      // Two-up on phones/tablets: let an odd last card span the full row
      '& > :last-child:nth-of-type(odd)': {
        gridColumn: { xs: '1 / -1', lg: 'auto' },
      },
    }}
  >
    {coverageItems.map((item) => (
      <Paper
        key={item.label}
        variant="outlined"
        sx={{ p: 1.25, borderRadius: 1.5 }}
      >
        <Stack gap={0.75}>
          <Stack direction="row" justifyContent="space-between" gap={1}>
            <Typography variant="body2" fontWeight={800}>
              {item.label}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {item.covered}/{item.total}
            </Typography>
          </Stack>
          <Box
            sx={{
              height: 7,
              borderRadius: 999,
              bgcolor: 'grey.200',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                height: '100%',
                width: `${item.percent}%`,
                bgcolor: getCoverageColor(item.percent),
                transition: 'width 200ms ease',
              }}
            />
          </Box>
          <Typography variant="caption" color="text.secondary">
            {item.percent}% covered
          </Typography>
        </Stack>
      </Paper>
    ))}
  </Box>
)

export default RosterCoverageCards
